import React from "react";
import { NavLink } from "react-router-dom";

/**
 * Segmented Journal | Notes header shown at the top of both /journal and /notes.
 * Tapping a segment switches routes; the active one is the currently loaded page.
 */
export default function JournalNotesTabs({ current }) {
    const items = [
        { to: "/journal", label: "Journal", key: "journal" },
        { to: "/notes", label: "Notes", key: "notes" },
    ];
    return (
        <div data-testid="journal-notes-tabs" className="mb-4">
            <div className="inline-flex p-1 rounded-full bg-white border border-ink-10">
                {items.map(it => {
                    const active = current === it.key;
                    return (
                        <NavLink
                            key={it.key}
                            to={it.to}
                            data-testid={`jn-tab-${it.key}`}
                            className={
                                "px-4 py-1.5 rounded-full font-ui text-[13px] transition " +
                                (active
                                    ? "bg-moss text-white font-medium"
                                    : "text-ink-70 hover:text-ink")
                            }
                        >
                            {it.label}
                        </NavLink>
                    );
                })}
            </div>
        </div>
    );
}
